import { getDefaultTypography } from '../utils'

export const ImageUploadDesignSettings = {
  'image-upload-design-width': {
    phone: [100],
    'phone-landscape': [100],
    tablet: [100],
    'tablet-landscape': [100],
    desktop: [100],
    tv: [100],
  },

  'image-upload-design-typography': {
    'image-upload-design-label-typography': {
      phone: getDefaultTypography('Body Large'),
      'phone-landscape': getDefaultTypography('Body Large'),
      tablet: getDefaultTypography('Body Large'),
      'tablet-landscape': getDefaultTypography('Body Large'),
      desktop: getDefaultTypography('Body Large'),
      tv: getDefaultTypography('Body Large'),
    },
    'image-upload-design-input-typography': {
      phone: getDefaultTypography('Body Large'),
      'phone-landscape': getDefaultTypography('Body Large'),
      tablet: getDefaultTypography('Body Large'),
      'tablet-landscape': getDefaultTypography('Body Large'),
      desktop: getDefaultTypography('Body Large'),
      tv: getDefaultTypography('Body Large'),
    },
    'image-upload-design-help-typography': {
      phone: getDefaultTypography('Body Small'),
      'phone-landscape': getDefaultTypography('Body Small'),
      tablet: getDefaultTypography('Body Small'),
      'tablet-landscape': getDefaultTypography('Body Small'),
      desktop: getDefaultTypography('Body Small'),
      tv: getDefaultTypography('Body Small'),
    },
  },
}
